require('./bootstrap');

import Global from "./general/global";
import Nav from "./general/nav";
import Appointment from "./general/appointment";

new Global()
new Nav();
new Appointment();
